import React from "react";
import { Button } from "#next/components/ui/button";
import { useStripeCheckout } from "#next/hooks/use-stripe-checkout";

interface CheckoutButtonProps {
  priceIds: string[],
  className?: string,
  children: React.ReactNode
}

export function CheckoutButton({
  priceIds, className, children
}: CheckoutButtonProps) {
  const { handleCheckout, isLoading, error } = useStripeCheckout({
    priceIds
  });

  return (
    <div className="relative w-full">
      <Button
        className={className}
        onClick={handleCheckout}
        disabled={isLoading}
      >
        {isLoading ? "Processing..." : children}
      </Button>
      {error && (
        <div className="text-red-500 mt-2 text-sm">
          Error: {error}
        </div>
      )}
    </div>
  );
}